import { Loader } from '@progress/kendo-react-indicators';
import PropTypes from 'prop-types';
import React from 'react';

export default function LoaderContainer(props) {
  return (
    <div
      className="justify-content-center align-items-center d-flex"
      style={props.style !== undefined ? props.style : undefined}
    >
      <Loader
        style={{ color: '#1e282c' }}
        size={'large'}
        type={'infinite-spinner'}
      />
    </div>
  );
}

LoaderContainer.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
